import { Building2 } from 'lucide-react'
import { cn } from '../../lib/utils'

/**
 * Tenant information to display in table cells
 */
export interface TenantInfo {
  name: string
  code: string
}

export interface TenantCellProps {
  /** Tenant data to display */
  tenant: TenantInfo | null | undefined
  /** Additional CSS classes */
  className?: string
}

/**
 * TenantCell - Reusable component for displaying tenant information in tables
 *
 * Shows tenant name with a Building2 icon.
 * Returns null if no tenant is provided.
 *
 * @example
 * ```tsx
 * <TenantCell tenant={{ name: 'Acme Corp', code: 'ACME001' }} />
 * ```
 */
export function TenantCell({ tenant, className }: TenantCellProps) {
  if (!tenant) return null

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Building2 className="h-4 w-4 text-muted-foreground flex-shrink-0" />
      <p className="text-sm truncate">{tenant.name}</p>
    </div>
  )
}
